import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';
import { FiCalendar, FiChevronLeft } from 'react-icons/fi';
import { motion } from 'framer-motion'; // <-- IMPORTADO PARA ANIMACIÓN
import '../styles/NoticiaDetalle.css';
import portadaImg from '../assets/images/portada.webp'; // <-- IMPORTADO PARA EL FONDO

const formatTimestamp = (timestamp) => {
    if (!timestamp) return null;
    const date = timestamp.toDate();
    return date.toLocaleDateString('es-ES', {
        year: 'numeric', month: 'long', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
    });
};

const getYoutubeEmbedUrl = (url) => {
    if (!url) return null;
    let videoId;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    if (match && match[1]) {
        videoId = match[1];
    } else {
        return null;
    }
    return `https://www.youtube.com/embed/${videoId}`;
};

const NoticiaDetalle = () => {
  const { noticiaId } = useParams();
  const [noticia, setNoticia] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNoticia = async () => {
      setLoading(true);
      const docRef = doc(db, 'noticias', noticiaId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setNoticia(docSnap.data());
      } else {
        console.log("No se encontró la noticia!");
      }
      setLoading(false);
    };
    fetchNoticia();
    window.scrollTo(0, 0);
  }, [noticiaId]);

  if (loading) {
    return <div className="detalle-loading">Cargando...</div>;
  }

  if (!noticia) {
    return (
        <div className="detalle-container not-found">
            <h2>Noticia no encontrada</h2>
            <p>El artículo que buscas no existe o ha sido movido.</p>
            <Link to="/noticias" className="back-link">
                <FiChevronLeft /> Volver a todas las noticias
            </Link>
        </div>
    );
  }
  
  const youtubeEmbedUrl = getYoutubeEmbedUrl(noticia.youtubeLink);

  return (
    <div className="detalle-page">
       <div className="detalle-background-image" style={{ backgroundImage: `url(${portadaImg})` }} />
      <motion.div 
        className="detalle-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <header className="detalle-header">
          <span className="detalle-category">{noticia.categoria}</span>
          <h1 className="detalle-title">{noticia.titulo}</h1>
          <div className="detalle-meta">
            <FiCalendar />
            <span>{formatTimestamp(noticia.fechaPublicacion) || 'Publicado recientemente'}</span>
          </div>
        </header>
        
        <div className="media-container">
            <img src={noticia.imagen} alt={noticia.titulo} className="detalle-image" />
        </div>
        
        {youtubeEmbedUrl && (
            <div className="video-container">
                <iframe
                    src={youtubeEmbedUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen>
                </iframe>
            </div>
        )}

        <article className="detalle-content">
          {noticia.contenido.split('\n').map((paragraph, index) => (
            paragraph.trim() !== '' && <p key={index}>{paragraph}</p>
          ))}
        </article>
        
        <div className="detalle-footer">
          <Link to="/noticias" className="back-link">
            <FiChevronLeft /> Volver a todas las noticias
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default NoticiaDetalle;